export const BreakpointSizes = Object.freeze({
  xs: Symbol('xs'),
  sm: Symbol('sm'),
  md: Symbol('md'),
  lg: Symbol('lg'),
  xl: Symbol('xl'),
});
